'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case constants.DELETE_MY_PLAYLIST_SUCCESS:
      {
        var myPlaylistsData = (0, _reject3.default)(state.myPlaylistsData, { guid: action.guid });
        return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
          myPlaylistsData: myPlaylistsData
        });
      }
    case constants.UPDATE_MY_PLAYLISTS_SUCCESS:
    case constants.ADD_MY_PLAYLIST_SUCCESS:
    case constants.ADD_MY_PLAYLIST_TRACKS_SUCCESS:
    case constants.DELETE_MY_PLAYLIST_TRACK_SUCCESS:
      {
        return (0, _extends4.default)({}, loadReducer.reducer(state, action), {
          myPlaylistsData: (0, _get3.default)(action, 'result.data', state.myPlaylistsData)
        });
      }
    case SET_MY_PLAYLISTS_FILTER:
      {
        return (0, _extends4.default)({}, state, {
          kw: action.kw
        });
      }
    case UPDATE_CHECKED_PLAYLISTS:
      {
        return (0, _extends4.default)({}, state, {
          checkedPlaylists: action.checkedPlaylists
        });
      }
    case CHECK_PLAYLIST:
      {
        return (0, _extends4.default)({}, state, {
          checkedPlaylists: (0, _extends4.default)({}, state.checkedPlaylists, (0, _defineProperty3.default)({}, action.guid, true))
        });
      }
    default:
      return reducer(state, action);
  }
};

exports.isLoaded = isLoaded;
exports.loadMyPlaylists = loadMyPlaylists;
exports.updateMyPlaylists = updateMyPlaylists;
exports.updateMyPlaylistName = updateMyPlaylistName;
exports.deleteMyPlaylist = deleteMyPlaylist;
exports.addMyPlaylist = addMyPlaylist;
exports.deleteMyPlaylistTrack = deleteMyPlaylistTrack;
exports.setMyPlaylistsFilter = setMyPlaylistsFilter;
exports.updateCheckedPlaylists = updateCheckedPlaylists;
exports.checkPlaylist = checkPlaylist;
exports.addMyPlaylistTracks = addMyPlaylistTracks;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _log = require('utils/log');

var _log2 = _interopRequireDefault(_log);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAG = 'modules/my-playlists'; /* Playlist redux reducer and action creators */

var SET_MY_PLAYLISTS_FILTER = 'myPlaylists/SET_MY_PLAYLISTS_FILTER';
var UPDATE_CHECKED_PLAYLISTS = 'myPlaylists/UPDATE_CHECKED_PLAYLISTS';
var CHECK_PLAYLIST = 'myPlaylists/CHECK_PLAYLIST';

var playlistActions = {
  noChanges: 0,
  changed: 1,
  removed: 2
};

var loadReducer = (0, _loadReducer2.default)('myPlaylists', {
  myPlaylists: {},
  updateMyPlaylists: {},
  deleteMyPlaylist: {},
  addMyPlaylist: {},
  deleteMyPlaylistTrack: {},
  addMyPlaylistTracks: {}
});

var reducer = loadReducer.reducer,
    constantsByKey = loadReducer.constantsByKey,
    constants = loadReducer.constants;


var initialState = (0, _extends4.default)({}, loadReducer.initialState, {
  kw: '',
  checkedPlaylists: {},
  myPlaylistsPopupVisible: false
});

function isLoaded() {
  return function (dispatch, getState) {
    return (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsLoaded');
  };
}

function loadMyPlaylists() {
  return {
    types: constantsByKey.myPlaylists,
    promise: function promise(client) {
      return client.post('viewer_wa/getMyPlaylists');
    }
  };
}

function getRequestArguments(_ref) {
  var playlist = _ref.playlist;

  var data = void 0;
  try {
    data = { playlist: (0, _stringify2.default)(playlist) };
  } catch (err) {
    _log2.default.warning(TAG, 'updateMyPlaylists stringify error');
  }

  return data;
}

function getPlaylistByGuid(_ref2) {
  var guid = _ref2.guid;

  return function (dispatch, getState) {
    var myPlaylists = (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsData', []);
    return (0, _find3.default)(myPlaylists, { guid: guid });
  };
}

function updateMyPlaylists(_ref3) {
  var playlist = _ref3.playlist;

  var data = getRequestArguments({ playlist: playlist });
  return {
    types: constantsByKey.updateMyPlaylists,
    promise: function promise(client) {
      return client.post('viewer_wa/setMyplaylist', { data: data });
    },
    playlist: playlist
  };
}

function updateMyPlaylistName(_ref4) {
  var guid = _ref4.guid,
      name = _ref4.name;

  return function (dispatch, getState) {
    var myPlaylists = (0, _get3.default)(getState(), 'myPlaylists.myPlaylistsData', []);
    var playlist = (0, _find3.default)(myPlaylists, { guid: guid });
    if (playlist) {
      var updatedPlaylist = (0, _extends4.default)({}, playlist);
      updatedPlaylist.name = name;
      updatedPlaylist.action = playlistActions.changed;
      return dispatch(updateMyPlaylists({ playlist: [updatedPlaylist] }));
    }
    return false;
  };
}

function deleteMyPlaylist(_ref5) {
  var guid = _ref5.guid;

  var data = getRequestArguments({
    playlist: [{
      guid: guid,
      action: playlistActions.removed,
      name: '',
      list: []
    }]
  });

  return {
    types: constantsByKey.deleteMyPlaylist,
    promise: function promise(client) {
      return client.post('viewer_wa/setMyplaylist', { data: data });
    },
    guid: guid
  };
}

function addMyPlaylist() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$name = _ref6.name,
      name = _ref6$name === undefined ? 'New playlist' : _ref6$name;

  var guid = (0, _uuid2.default)();
  var data = getRequestArguments({
    playlist: [{
      guid: guid,
      action: playlistActions.changed,
      name: name,
      list: []
    }]
  });

  return {
    types: constantsByKey.addMyPlaylist,
    promise: function promise(client) {
      return client.post('viewer_wa/setMyplaylist', { data: data });
    },
    guid: guid
  };
}

function deleteMyPlaylistTrack(_ref7) {
  var guid = _ref7.guid,
      trackId = _ref7.trackId;

  return function (dispatch) {
    var playlist = (0, _extends4.default)({}, dispatch(getPlaylistByGuid({ guid: guid })));
    if (playlist) {
      playlist.list = playlist.list.filter(function (id) {
        return id !== trackId;
      });
      playlist.action = playlistActions.changed;
      var data = getRequestArguments({ playlist: [playlist] });
      return dispatch({
        types: constantsByKey.deleteMyPlaylistTrack,
        promise: function promise(client) {
          return client.post('viewer_wa/setMyplaylist', { data: data });
        },
        guid: guid,
        trackId: trackId
      });
    }
    return null;
  };
}

function setMyPlaylistsFilter(_ref8) {
  var kw = _ref8.kw;

  return {
    type: SET_MY_PLAYLISTS_FILTER,
    kw: kw
  };
}

function updateCheckedPlaylists(checkedPlaylists) {
  return {
    type: UPDATE_CHECKED_PLAYLISTS,
    checkedPlaylists: checkedPlaylists
  };
}

function checkPlaylist(_ref9) {
  var guid = _ref9.guid;

  return {
    type: CHECK_PLAYLIST,
    guid: guid
  };
}

function addMyPlaylistTracks(_ref10) {
  var guids = _ref10.guids,
      tracksId = _ref10.tracksId;

  return function (dispatch) {
    var playlists = [];
    guids.map(function (guid) {
      var playlist = (0, _extends4.default)({}, dispatch(getPlaylistByGuid({ guid: guid })));
      if (playlist) {
        playlist.list = [].concat((0, _toConsumableArray3.default)(playlist.list), (0, _toConsumableArray3.default)(tracksId));
        playlist.action = playlistActions.changed;
        playlists.push(playlist);
      }
    });
    if (playlists.length) {
      var data = getRequestArguments({ playlist: playlists });
      return dispatch({
        types: constantsByKey.addMyPlaylistTracks,
        promise: function promise(client) {
          return client.post('viewer_wa/setMyplaylist', { data: data });
        },
        guids: guids,
        tracksId: tracksId
      });
    }
    return {};
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/my-playlists.js
// module id = 88
// module chunks = 1